import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@bingads-webui-react/primitive';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-control';

const ConfirmDialog = (props) => {
  const {
    isDisplayed,
    title,
    errorText,
    confirmString,
    cancelString,
    onClickConfirm,
    onClickCancel,
    isUiBlocked,
    warningMsg,
    customStyle,
  } = props;

  return (
    <Modal
      id="asset-delete-confirmation-dialog"
      className="confirmation-dialog"
      animation={false}
      show={isDisplayed}
      backdrop="static"
      onHide={onClickCancel}
      bsSize="lg"
      style={customStyle}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="image-delete-warning warning-msg" style={{ color: 'rgb(168,0,0)' }}>
          {warningMsg}
        </div>
        <div className="image-delete-error delete-error" style={{ color: 'rgb(168,0,0)' }}>
          {errorText}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          disabled={errorText.length > 0 || isUiBlocked}
          className="dialog-confirm-button"
          onClick={onClickConfirm}
        >
          {confirmString}
        </PrimaryButton>
        <DefaultButton
          disabled={isUiBlocked}
          className="dialog-cancel-button"
          onClick={onClickCancel}
          style={{ marginLeft: '8px' }}
        >
          {cancelString}
        </DefaultButton>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  isDisplayed: PropTypes.bool.isRequired,
  isUiBlocked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  warningMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmString: PropTypes.string.isRequired,
  cancelString: PropTypes.string.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  customStyle: PropTypes.shape({}),
};

ConfirmDialog.defaultProps = {
  errorText: '',
  warningMsg: '',
  isUiBlocked: false,
  customStyle: null,
};

export { ConfirmDialog };
